import axios from '@/utils/axios';
import { useState } from 'react';
import { useQuery } from 'react-query';

export const useEpvFamilies = () =>
	useQuery(
		['epv_families'],
		() => axios.get<TEpvFamily[]>('/get_epv_families'),
		{
			select: ({ data }) => data,
		}
	);

export const useCapacityTypes = () => {
	const [listOrder, setListOrder] = useState<Record<string, number>>({});

	const query = useQuery(
		['capacity_types'],
		() => axios.get<TCapacityType>('/capacity_types'),
		{
			select: ({ data }) => data,
			onSuccess: (data) => {
				const order: Record<string, number> = {};
				for (const [index, [key, value]] of Object.entries(
					Object.entries(data)
				)) {
					order[key] = parseInt(index);
				}
				setListOrder(order);
			},
		}
	);
	return {
		query,
		order: listOrder,
	};
};

export const useProcessSteps = () =>
	useQuery(
		['process_steps'],
		() => axios.get<TCapacityType>('/process_steps'),
		{
			select: ({ data }) => data,
		}
	);

export const useGLobalRegions = () =>
	useQuery(
		['global_regions'],
		() => axios.get<string[]>('/get_global_regions'),
		{
			select: ({ data }) => data,
		}
	);
